import { DecimalProperty } from "@megarax/client/src/resources/plm/Property";
import {
  TransformedInput,
  DecimalStringInput,
} from "@/components/form/InputFields";
import { createComponent, createElement } from "@vue/composition-api";

interface Props {
  value: DecimalProperty;
}

const inputTransform = (input: string) => {
  if (!input) return null;
  const num = parseFloat(input);
  return { value: num, tolerance: 0 };
};

const valueTransform = (value: { value: number } | null | undefined) => {
  if (!value) return "";
  else return value.value;
};

const DecimalPropertyInput = createComponent({
  props: {
    value: { required: true },
  },
  name: "DecimalPropertyInput",
  setup(props, ctx) {
    return () =>
      createElement(TransformedInput, {
        props: {
          value: props.value,
          inputComponent: DecimalStringInput,
          inputTransform,
          valueTransform,
        },
        on: ctx.listeners,
      });
  },
});

export default DecimalPropertyInput;
